import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { addSongMessages } from './addSongMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole page; each part uses its own slice of it */
import styles from './AddSongView.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** `exists`: the song is in the catalog already (409). `save`: any other failure of the catalog call. */
export type AddSongErrorReason = 'exists' | 'save';

interface AddSongErrorLineProps {
  reason: AddSongErrorReason;
  title: string;
  /** Set when the row in the catalog is found: it becomes the first release. */
  onOpenExisting?: () => void;
}

/** The save errors of design c3: "Already in the catalog" (info) and "Save failed" (error). */
const AddSongErrorLineComponent: React.FC<AddSongErrorLineProps> = ({ reason, title, onOpenExisting }) => {
  const intl = useIntl();

  if (reason === 'exists') {
    return (
      <div className={styles.alertInfo} role="status">
        {intl.formatMessage(addSongMessages.errorExists, { title })}{' '}
        {onOpenExisting !== undefined && (
          <button type="button" className={styles.linkButton} onClick={onOpenExisting}>
            {intl.formatMessage(addSongMessages.errorExistsOpen)}
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={styles.alertError} role="alert">
      {intl.formatMessage(addSongMessages.errorSave)}
    </div>
  );
};

export const AddSongErrorLine = TypedMemo(AddSongErrorLineComponent);
